const Languages = [
	{
		"id": 0,
		"name": "Choose a Language",
		"code": "en"
	},
	{
		"id": 1,
		"name": "English",
		"code": "en"
	},
	{
		"id": 2,
		"name": "Arabic",
		"code": "ar"
	},
	{
		"id": 3,
		"name": "Português",
		"code": "br"
	},
	{
		"id": 4,
		"name": "官话",
		"code": "cn"
	},
	{
		"id": 5,
		"name": "Deutsch",
		"code": "de"
	},
	{
		"id": 6,
		"name": "Español",
		"code": "es"
	},
	{
		"id": 7,
		"name": "Français",
		"code": "fr"
	},
	{
		"id": 8,
		"name": "हिंदी",
		"code": "hi"
	},
	{
		"id": 9,
		"name": "Bahasa Indonesia",
		"code": "id"
	},
	{
		"id": 10,
		"name": "Italiano",
		"code": "it"
	},
	{
		"id": 11,
		"name": "日本語",
		"code": "jp"
	},
	{
		"id": 12,
		"name": "한국어",
		"code": "kr"
	},
	{
		"id": 13,
		"name": "Español",
		"code": "mx"
	},
	{
		"id": 14,
		"name": "بهاس مليسيا‎",
		"code": "my"
	},
	{
		"id": 15,
		"name": "Polska",
		"code": "po"
	},
	{
		"id": 16,
		"name": "русский язык",
		"code": "ru"
	},
	{
		"id": 17,
		"name": "Svenska",
		"code": "se"
	},
	{
		"id": 18,
		"name": "ภาษาไทย",
		"code": "th"
	},
	{
		"id": 19,
		"name": "Türkçe",
		"code": "tr"
	},
	{
		"id": 20,
		"name": "官話",
		"code": "tw"
	},
	{
		"id": 21,
		"name": "tiếng việt (㗂越)",
		"code": "vi"
	}
];

export { Languages };
